module.exports = __webpack_public_path__ + "img/oltasok_macska.b367008f.jpg";